import { CSSObject } from 'styled-components';

export default function createMixins(): Record<string, CSSObject> {
  return {
    absoluteFill: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
  };
}
